module.exports = __webpack_public_path__ + "static/media/AIRASP_location.7f42e458.png";